import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { ChannelServiceRB } from 'rainbow-web-sdk/services/channels/channel.service';

export class ChannelsPlugin extends Plugin {
    public static initialize(): ChannelsPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[ChannelsPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[ChannelsPlugin] initialized");
            window.rainbow.plugins[ChannelsPlugin.name] = new ChannelsPlugin();
            ChannelServiceRB.getInstance();
        }
        return window.rainbow.plugins[ChannelsPlugin.name];
    }

    private constructor() {
        super();
    }
}
